var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { withFieldMetadata } from '../enhancers/withFieldMetadata';
import { withEmptyFieldEditingComponent } from '../enhancers/withEmptyFieldEditingComponent';
import { DefaultEmptyFieldEditingComponentText } from './DefaultEmptyFieldEditingComponents';
import PropTypes from 'prop-types';
import { isFieldValueEmpty } from '@sitecore-jss/sitecore-jss/layout';
export const Text = withFieldMetadata(withEmptyFieldEditingComponent((_a) => {
    var { field, tag, editable = true, encode = true } = _a, otherProps = __rest(_a, ["field", "tag", "editable", "encode"]);
    if (!field || (!field.editable && isFieldValueEmpty(field))) {
        return null;
    }
    // can't use editable value if we want to output unencoded
    if (!encode) {
        // eslint-disable-next-line no-param-reassign
        editable = false;
    }
    const isEditable = field.editable && editable;
    let output = isEditable
        ? field.editable || ''
        : field.value === undefined
            ? ''
            : field.value;
    // when string value isn't formatted, we should format line breaks
    if (!field.editable && typeof output === 'string') {
        const splitted = String(output).split('\n');
        if (splitted.length) {
            const formatted = [];
            splitted.forEach((str, i) => {
                const isLast = i === splitted.length - 1;
                formatted.push(str);
                if (!isLast) {
                    formatted.push(React.createElement("br", { key: i }));
                }
            });
            output = formatted;
        }
    }
    const setDangerously = isEditable || !encode;
    let children = null;
    const htmlProps = Object.assign({}, otherProps);
    if (setDangerously) {
        htmlProps.dangerouslySetInnerHTML = {
            __html: output,
        };
    }
    else {
        children = output;
    }
    if (tag || setDangerously) {
        return React.createElement(tag || 'span', htmlProps, children);
    }
    else {
        return React.createElement(React.Fragment, null, children);
    }
}, { defaultEmptyFieldEditingComponent: DefaultEmptyFieldEditingComponentText }));
Text.propTypes = {
    field: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        editable: PropTypes.string,
        metadata: PropTypes.objectOf(PropTypes.any),
    }),
    tag: PropTypes.string,
    editable: PropTypes.bool,
    encode: PropTypes.bool,
    emptyFieldEditingComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
};
Text.displayName = 'Text';
